import { getUserPasswordPolicies, type Policies } from '@flippingbook/web.utils/dist/util/getUserPasswordPolicies';

import { loc } from '@/localization';

const userPasswordPoliciesTexts: Record<Policies, string> = {
    minLength: loc.Validation.PasswordPolicyMinLength,
    uppercaseLetter: loc.Validation.PasswordPolicyUppercase,
    lowercaseLetter: loc.Validation.PasswordPolicyLowercase,
    oneNumber: loc.Validation.PasswordPolicyOneNumber,
    specialCharacter: loc.Validation.PasswordPolicySpecialCharacter,
};

export function getPolicyErrorMessage(errors: string[]) {
    const lowerCaseErrors = errors.map((error) => error.toLowerCase());
    const lastIndex = lowerCaseErrors.length - 1;

    if (errors.length < 3) {
        return `${loc.Validation.PasswordMustInclude} ${lowerCaseErrors.join(` ${loc.Main.And} `)}`;
    }

    return `${loc.Validation.PasswordMustInclude} ${lowerCaseErrors.slice(0, lastIndex).join(', ')}, ${loc.Main.And} ${lowerCaseErrors[lastIndex]}`;
}

export const userPasswordPoliciesList = Object.values(userPasswordPoliciesTexts);

export const userPasswordPolicies = getUserPasswordPolicies(userPasswordPoliciesTexts);
